export default function AdminPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Admin</h1>
      <p className="text-muted-foreground">Admin dashboard will be displayed here.</p>
    </div>
  );
}
